import cloneDeep from 'lodash/cloneDeep';
import forEach from 'lodash/forEach';
import AppResource from './../Data/AppResource';
import AppResourceCollection from "../Data/AppResourceCollection";


class ApiResponse {

    constructor(apiResponseData) {
        this._rawData = {
            status: 200,
            statusMessage: 'OK',
            errors: {},
            warnings: {},
            data: [],
            meta: {},
            ...cloneDeep(apiResponseData)
        };

        this._status = this._rawData.status;
        this._statusMessage = this._rawData.statusMessage;
        this._warnings = this._rawData.warnings;
        this._errors = this._rawData.errors;
        this._meta = this._rawData.meta;
        this._appResourceCollection = null;

        if (Array.isArray(this._rawData.data)) {
            for (let i = 0; i < this._rawData.data.length; i++) {
                this.addResource(this._rawData.data[i]);
            }
        } else if (
            typeof this._rawData.data === "object" &&
            AppResource.hasAppResourceStructure(this._rawData.data)
        ) {
            this.addResource(this._rawData.data);
        } else if (typeof this._rawData.data === "object") {
            forEach(this._rawData.data, item => {
                if (item && AppResource.hasAppResourceStructure(item.resource)) {
                    this.addResource(item.resource);
                }
            });
        }
    }

    /**
     * @returns {boolean}
     */
    get isSuccess() {
        return this.status === 200;
    }

    /**
     * @returns {boolean}
     */
    get isError() {
        return !this.isSuccess;
    }

    /**
     * @returns {null|AppResourceCollection}
     */
    get resources() {
        return this.appResourceCollection;
    }

    /**
     * @returns {null|AppResourceCollection}
     */
    get appResourceCollection() {
        return this._appResourceCollection;
    }

    /**
     * @returns {*}
     */
    get meta() {
        return this._meta;
    }

    get rawData() {
        return this._rawData;
    }

    get status() {
        return this._status;
    }

    get statusMessage() {
        return this._statusMessage;
    }

    get errors() {
        return this._errors;
    }

    get warnings() {
        return this._warnings;
    }

    /**
     * @param resourceData
     */
    addResource(resourceData) {
        const resource = AppResource.buildFromData(resourceData, true);
        if (resource === null) {
            return;
        }
        if (this.appResourceCollection === null) {
            this._appResourceCollection = new AppResourceCollection(resource.resourceType);
        }
        this._appResourceCollection.addResource(resource);
    }
}

export default ApiResponse;
